import { render } from 'preact';
import { App } from './App';
import { setup } from "@twind/core";
import { config } from "../twind.config";

setup(config);
render(<App />, document.getElementById('app')!);
